<template>
  <div
    class="mood-inverse flex min-h-screen flex-col items-center justify-center bg-[#191c20] px-24 py-48 text-static-default-hi"
  >
    <div class="flex flex-col items-center text-center">
      <div class="bg-static-danger-low rounded-full p-4">
        <IconCrossInCircle class="text-static-danger-hi" size="48" />
      </div>

      <h1 class="heading-1 mt-16">
        {{ i18n(translations.title) }}
      </h1>

      <p class="body-1 text-static-default-low mt-8">
        {{ i18n(translations.description) }}
      </p>

      <RevButton variant="primary" class="mt-20" @click="onRetry">
        {{ i18n(translations.tryAgain) }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { IconCrossInCircle } from '@ds/icons/IconCrossInCircle'

import translations from './ErrorPage.translations'

const i18n = useI18n()

function onRetry() {
  window.location.reload()
}
</script>
